import {
  CONDITION_SEVERITY,
  DEMAND_ICON_MAP,
  DEMAND_TYPE_MAP,
  DEMAND_TYPES,
  GOAL_SEVERITY
} from '@/models/demands'

export function isDemandActive(demand) {
  return ![CONDITION_SEVERITY.INACTIVE, GOAL_SEVERITY.DONE].includes(
    demand.severity
  )
}

/**
 * Get demand description normalized according demand type
 * @param {Object} demand
 * @returns string
 */
export function getDemandDescription(demand) {
  if (demand.description.type === DEMAND_TYPES.GOAL) {
    return normalizeGoalDescription(demand.description?.description)
  }
  const description = normalizeConditionDescription(
    demand.description?.description,
    demand.description?.value
  )

  return description
}

/**
 * Get desease description according demand type
 * @param {Object} disease {type: string, id: string, description: string, value: string}
 * @returns
 */
export function getDiseaseDescription(disease) {
  if (disease.type === DEMAND_TYPES.GOAL) {
    return normalizeGoalDescription(disease.description)
  }
  const description = normalizeConditionDescription(
    disease.description,
    disease.value
  )

  return description
}

export function normalizeGoalDescription(description) {
  try {
    const splittedGoal = description?.split(' - ')
    return splittedGoal[1]
      ? `${splittedGoal[0]} - ${splittedGoal[1]} `
      : `${splittedGoal[0]}`
  } catch (error) {
    return description
  }
}

/**
 * Get demand description of type condition (CID/CIAP) and value.
 * Remove unused data. Ex: Teste VIC - CID AV1 = Teste VIC
 * @param {string} conditionDescription
 * @param {string} conditionValue
 * @returns string
 */
export function normalizeConditionDescription(
  conditionDescription,
  conditionValue
) {
  const description = conditionDescription
    .replace(DEMAND_TYPE_MAP.CID_10, '')
    .replace(DEMAND_TYPE_MAP.CIAP_2, '')
    .replace(' - ', '')
    .replace(conditionValue, '')
  return description
}

/**
 * Get demand slug label
 * demand {
 * value
 * type
 * }
 * @param {*} demand
 * @returns
 */
export const getDemandLabel = demand => {
  return demand.description.type === DEMAND_TYPES.GOAL
    ? demand.description.value
    : `${DEMAND_TYPE_MAP[demand.description.type]} ${demand.description.value}`
}

export const getDemandTagLabel = demand => {
  return `${getDemandLabel(demand)} • ${getDemandDescription(demand)}`
}

/**
 * Create a demand code from concat splitted type + description value
 * @param {Object} demand
 * @returns
 */
export const getDemandCode = demand => {
  if (demand.description.type === DEMAND_TYPES.GOAL) return ''

  const type = demand.description.type.split('_')[0]
  return `${type} ${demand.description.value}`
}

export const getDemandIcon = demandType => {
  return demandType ? DEMAND_ICON_MAP[demandType] : ''
}

/**
 * Check if demand is new for staff
 * @param {Channel object{startedAt.seconds}} demand
 * @param {Date} lastSync
 * @returns
 */
export const checkNewDemand = (demand, lastSync) => {
  if (!lastSync) {
    return false
  }
  return demand.startedAt?.seconds > lastSync.getTime() / 1000
}

const splitValueAndDescription = demandTitle => {
  const [value, ...description] = demandTitle.split(' - ')
  return { value, description: description.join(' - ') }
}

export const normalizeDemandObject = caseRecord => {
  const { id, title, category } = caseRecord
  const { value, description } = splitValueAndDescription(title)
  return {
    id,
    value,
    description,
    type: category
  }
}
